import React, { useEffect } from 'react'
import mapper from '../_endpoints'
import { IconEye } from '@tabler/icons-react'
import { useFetch } from './useFetch'

export default function useCategoriesHook() {
  const [categories, setCategories] = React.useState([])
  const [, getCategoriesData] = useFetch()

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await getCategoriesData(mapper.categories.get)

      const navCategories = []

      response.map((item) =>
        navCategories.push({
          title: item.category.name,
          icon: <IconEye size={20} />, //item.category.icon.url,
          id: item.category.id,
          navLink: `/categories/${item.category.id}`
        })
      )

      setCategories(navCategories)
    }
    fetchCategories()
  }, [])

  return categories
}
